module.exports = __webpack_public_path__ + "static/celebrating-our-successes-2fea8683e5709133a66d719f9840ec62.jpg";